const envs = {
  development: {
    name: "development",
    host: "http://develop.movidesk.com/public/v1/survey"
  },
  production: {
    name: "production",
    host: "https://api.movidesk.com/public/v1/survey"
  },
  staging: { name: "staging", host: "http://35.227.101.166/public/v1/survey" },
  hamburg: {
    name: "hamburg",
    host:
      "https://customercare-pesquisa-homo.hamburgsud.com/api/public/v1/survey"
  },
  productionMovidesk: {
    name: "productionMovidesk",
    host: "/SatisfactionSurvey"
  }
};

module.exports = envs;
